export const removeCached = ({ cache, label }) => cache.removeItem(label);
